// extracted by mini-css-extract-plugin
export default {"wrapper":"AccountPane_wrapper__PlpL8","info":"AccountPane_info__Rq9CN","preferences":"AccountPane_preferences__oqdtP"};